import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/imgs/inserts/afex-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-0b70e99c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Forex Remittance", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Because the risks of margining are not marginal.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "two-thirds half-lg" }, [
  /*#__PURE__*/_createElementVNode("p", null, "The Derivitec Risk Portal allow you to compute your margin requirements to your dealing banks, and the margin requirements from your clients, under whatever market scenario you choose. Imagine you had known, in detail, which client, on which book, managed by which dealer, on which product, was going to suffer on the 24th June 2016. Our clients did, and managed the crisis effectively, before it happened. Imagine each client, from individual to corporate, could see their collateral risk clearly and intuitively, every day, top to bottom. With our Python reporting technology integrating into your in house client portal, they can."),
  /*#__PURE__*/_createElementVNode("strong", null, "The days of ‘not knowing’ are over.")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns transparency" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "static divider" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Features & Benefits"),
    /*#__PURE__*/_createElementVNode("h4", null, "Transparency"),
    /*#__PURE__*/_createElementVNode("p", null, "All divisions of your organisation, be they trading, treasury, credit or operations, can see exactly where your risks are, on exactly the same basis. Every client can see precisely what they need to know, down to the last detail, in exactly the way you want them to see it.")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "static divider" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Flexibility"),
    /*#__PURE__*/_createElementVNode("p", null, "No two remittance firms compute margin the same way. No two dealing banks likewise. Derivitec will work with you to implement the margin rules of you and your liquidity providers, exactly, in our system, and will update accordingly as things change.")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns detail" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "static divider" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Detail"),
    /*#__PURE__*/_createElementVNode("p", null, "You don’t just need to know where your risks are, you need to know why, and what you can do to manage them. Derivitec takes all the information you’re prepared to give us, down to who traded what, for who, when, so you can drill down to the last detail when things look problematic, before they become a problem.")
  ])
], -1))
const _hoisted_7 = { class: "third" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "company-logo",
  src: _imports_0
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "two-thirds" }, [
  /*#__PURE__*/_createElementVNode("blockquote", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Derivitec has been instrumental in helping us manage counterparty collateral in the wake of the Brexit shock."),
    /*#__PURE__*/_createElementVNode("p", null, "Its real value was really prior to the event itself, when we were able to stress test portfolios and warn clients of impending collateral requirements as well as potential negative market movements so that clients would be prepared well in advance. This helped clients assess the cash flow impact to their business and decide how they wished to manage the uncertainty risk around the possible outcomes of the referendum."),
    /*#__PURE__*/_createElementVNode("footer", null, [
      /*#__PURE__*/_createElementVNode("cite", null, "Sheila Krishnan"),
      /*#__PURE__*/_createElementVNode("p", null, "Global Credit Manager | AFEX")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel = _resolveComponent("panel")!
  const _component_client_box = _resolveComponent("client-box")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_panel, {
      class: "head",
      bg: true
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "portal columns right" }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "features" }, {
      default: _withCtx(() => [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "columns" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_client_box, {
            standalone: true,
            "no-border": true
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _hoisted_9
      ]),
      _: 1
    })
  ]))
}